import React, { useEffect, useState } from "react";
import { GeoJSON } from "react-leaflet";

let cached = null;

const STYLE = {
  color: "#3D4852",
  weight: 1.6,
  dashArray: "6 4",
  opacity: 0.8,
  fill: false,
};

export default function CountyLinesLayer() {
  const [data, setData] = useState(cached);

  useEffect(() => {
    if (cached) return;
    fetch("/wa_counties.geojson")
      .then((r) => r.json())
      .then((d) => {
        cached = d;
        setData(d);
      })
      .catch(() => {});
  }, []);

  if (!data) return null;
  // interactive=false: boundary lines are purely visual — hit-testing 39
  // full-county polygons on every mousemove makes panning choppy.
  return <GeoJSON data={data} interactive={false} style={STYLE} />;
}
